import { physicalBaseQuery } from "../observability/web/runtime";
import config from "./config";
import { getAuthToken } from "../stores/auth.store";
import { triggerGa } from "./gaUtils";
import { GA_ACTION, GA_CATEGORIES, GA_LABEL } from "./constants";
import { APIS_ENDPOINT } from "./api_constants";
import { getAppBuildVersion, getPlatform, getWebAppVersion } from "./config";

export const baseQuery = physicalBaseQuery({
  baseUrl: config.API.url,
  prepareHeaders: async (headers, { getState, endpoint }) => {
    // The login call itself must not wait on auth state, or it deadlocks.
    if (endpoint === "postFirebaseLogin") return;
    const authToken = await getAuthToken();
    authToken && headers.set("Authorization", `Token ${authToken}`);
    headers.set("x-native-build", String(getAppBuildVersion()));
    headers.set("x-web-app-version", getWebAppVersion() || "0.0.0");
    headers.set("x-platform", getPlatform());
    return headers;
  },
});

export const getQueryStringWithCreator = (query) => {
  const creator = localStorage.username?.replaceAll('"', "");
  if (creator) {
    let encodedCreator = encodeURIComponent(creator);
    if (query.includes("?")) query += `&creator=${encodedCreator}`;
    else query += `?creator=${encodedCreator}`;
  }
  return query;
};

export const baseQueryWithArgs = async (args, api, extraOptions) => {
  let result = null;
  try {
    const endpoint = api.endpoint;
    const addEventLog = APIS_ENDPOINT[endpoint]?.addTimingLogs;
    if (addEventLog) {
      triggerGa({
        category: GA_CATEGORIES.WEB_VITALS,
        action: GA_ACTION.API_CALL_STARTED,
        label: `${GA_LABEL.API_CALL}_${api.endpoint}`,
        eventValue: Date.now(),
      });
    }
    result = await baseQuery(args, api, extraOptions);
    const status = result?.meta?.response?.status;
    if (
      result?.error &&
      (result?.error?.status === 403 || result?.error?.status === 401)
    ) {
      await getAuthToken({ force: true });
      result = await baseQuery(args, api, extraOptions);
    }
    if (addEventLog) {
      triggerGa({
        category: GA_CATEGORIES.WEB_VITALS,
        action: GA_ACTION.API_CALL_END,
        label: `${GA_LABEL.API_CALL}_${api.endpoint}`,
        eventValue: Date.now(),
        label2: status,
      });
    }
    return result;
  } catch (e) {
    return result;
  }
};

export const postQueryBodyWithCreator = (body) => {
  const creator = localStorage.username?.replaceAll('"', "");
  if (creator) {
    if (!body.creator) body.creator = creator;
  }
  return body;
};
